'use client';

import { Content, GroupField } from '@prismicio/client';
import { Simplify } from '../../../../prismicio-types';
import Card from './Card';
import { useScreenSize } from '@/hooks';
import styles from './Card.module.scss';

interface Props {
  cards: GroupField<
    Simplify<Content.PartnerBenefitsSliceDefaultPrimaryCardsItem>
  >;
}

const Cards = ({ cards }: Props) => {
  const screenSize = useScreenSize();

  return (
    <ul className={styles.cardsWrapper}>
      {cards.map((card) => (
        <Card data={card} key={card.title} screenSize={screenSize} />
      ))}
    </ul>
  );
};

export default Cards;
